import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=98274650&"
import script from "./CrudTable.vue?vue&type=script&lang=js&"
export * from "./CrudTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports